import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[luiCardBadge]',
    standalone: false
})
export class CardBadgeDirective {
  @HostBinding('class') className = 'lui-card-badge';
}
